import React from 'react';
import { ProgressBar } from 'components/views/atoms/ProgressBar';
import styled from '@emotion/styled';
import { SliderBar } from 'components/views/atoms/SliderBar';

const Frame = styled.div({
    height: '100%',
    minHeight: '195px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
});

const Group = styled.div({
    //height: '25%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    ['> h4']: {
        margin: 0,
        fontSize: '14px',
        fontWeight: 500,
    },
});

export type DriveInfoProps = {
    className?: string;
    steeringPosition: number;
    controllerSteeringPosition: number;
    controllerAccel: number;
    controllerBrake: number;
}

export const DriveInfo = (props: DriveInfoProps) => {
    const animationSpeed = undefined;

    return (
        <Frame className={props.className}>
            <Group>
                <h4>Steering Position</h4>
                <SliderBar ratio={(-props.steeringPosition + 1) / 2} speed={animationSpeed} />
            </Group>
            <Group>
                <h4>Controller Steering Position</h4>
                <SliderBar ratio={(props.controllerSteeringPosition + 1) / 2} speed={animationSpeed} />
            </Group>
            <Group>
                <h4>Controller Accel</h4>
                <ProgressBar ratio={props.controllerAccel} speed={animationSpeed} />
            </Group>
            <Group>
                <h4>Controller Brake</h4>
                <ProgressBar ratio={props.controllerBrake} speed={animationSpeed} />
            </Group>
        </Frame>
    );
};
